
export const MaritalStatusOptions: { label: string; value: string }[] = [
    { label: 'Single', value: 'single' },
    { label: 'Married', value: 'married' },
    { label: 'Divorced', value: 'divorced' },
    { label: 'Widowed', value: 'widowed' },
 ]
export const RegionOptions: { label: string; value: string }[] = [ 
    { label: 'Arewa Community', value: '1' },
    { label: 'Igbo Community', value: '2' },
    { label: 'South South Community', value: '3' },
    { label: 'Yoruba Community', value: '4' },
 ]
export const NetworkOptions: { label: string; value: string }[] = [ 
    { label: 'MTN', value: 'MTN' },
    { label: 'Telecel', value: 'VOD' },
    { label: 'AirTel', value: 'AIR' },
 ]
export const itemToString = <T extends { label: string; value: string } >(list: T[]) => (value: string) => list.find(i => i.value === value)?.label ?? ''
